var _g;
var _excluded = ["svgRef", "title"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import React from "react";
var SvgMenu01 = function SvgMenu01(_ref) {
  var svgRef = _ref.svgRef,
    title = _ref.title,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Lager_1",
    x: "0px",
    y: "0px",
    viewBox: "-4.5 -7 32 32",
    enableBackground: "new 0 0 23.1 18.3",
    xmlSpace: "preserve",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#0",
    d: "M1.2,2.5h20.6c0.7,0,1.2-0.6,1.2-1.2S22.5,0,21.8,0H1.2C0.6,0,0,0.6,0,1.2S0.6,2.5,1.2,2.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#0",
    d: "M21.8,7.9H1.2C0.6,7.9,0,8.4,0,9.1s0.6,1.2,1.2,1.2h20.6c0.7,0,1.2-0.6,1.2-1.2S22.5,7.9,21.8,7.9z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#0",
    d: "M21.8,15.8H1.2C0.6,15.8,0,16.3,0,17s0.6,1.2,1.2,1.2h20.6c0.7,0,1.2-0.6,1.2-1.2S22.5,15.8,21.8,15.8z"
  }))));
};
var ForwardRef = React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgMenu01, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/menu-01.7093f904.svg";
export { ForwardRef as ReactComponent };